<div>
  <form [formGroup]="createInvoiceModalForm" novalidate>

    <ng-container *ngFor = "let formCtrl of formData">
      <div class="formfields__container form-wrapper"
        *ngIf="formCtrl.id === 'project'">
        <label for="project-id">
          <span id="project-id" i18n>Project</span>
          <span class="required">*</span>
        </label>
        <mat-select id="team-id-type" [formControlName]="formCtrl.id" [placeholder]="formCtrl.placeHolderLabel" i18n-placeholder
          floatPlaceholder="never">
          <mat-option *ngFor="let project of formCtrl.list" [value]="project.value">
            <span id="project-id-{{project.value}}">
              {{ project.label }}
            </span>
          </mat-option>
        </mat-select>
      </div>

      <div class="formfields__container form-wrapper" *ngIf="formCtrl.id !== 'project'">
        <label for="{{formCtrl.id}}-id">
          <span id="{{formCtrl.id}}-id">{{formCtrl.label}}</span>
          <span class="required" *ngIf="formCtrl.isRequired">*</span>
          <span class="optional-label">({{formCtrl.optionalLabel}})</span>
        </label>
        <iv-multiselect-autocomplete
          id="{{formCtrl.id}}-type"
          [list]="formCtrl.list"
          [key]="'label'"
          [placeHolderLabel]="'Search'" i18n-placeholderLabel
          [selectedValues]="formCtrl?.selectedValues"
          [multiSelectCtrl]="createInvoiceModalForm.get(formCtrl.id)"
          [data]="formCtrl"
          [selectAll]="formCtrl.isMultiSelect">
        </iv-multiselect-autocomplete>
      </div>
    </ng-container>

  </form>
</div>
